// extracted by mini-css-extract-plugin
export var arrow = "Banner-module--arrow--ec98f";
export var banner = "Banner-module--banner--00be1";
export var button = "Banner-module--button--946f0";
export var company = "Banner-module--company--2aa04";
export var decor = "Banner-module--decor--fb8d9";
export var heading = "Banner-module--heading--0ab8d";
export var image = "Banner-module--image--3c4ae";
export var lineAbove = "Banner-module--lineAbove--cf7d5";
export var mobile = "Banner-module--mobile--ac8c1";
export var next = "Banner-module--next--e369b";
export var prev = "Banner-module--prev--cf560";
export var relativeWrapper = "Banner-module--relativeWrapper--1fce0";
export var title = "Banner-module--title--b2169";